export default __webpack_public_path__ + "img/52.389a048.svg";